import { render, staticRenderFns } from "./TelegramLinkQrCode.vue?vue&type=template&id=c0352ece"
import script from "./TelegramLinkQrCode.vue?vue&type=script&lang=ts&setup=true"
export * from "./TelegramLinkQrCode.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports